import { render, staticRenderFns } from "./SetLogsSize.vue?vue&type=template&id=6806c65f&scoped=true&lang=pug&"
import script from "./SetLogsSize.vue?vue&type=script&lang=js&"
export * from "./SetLogsSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806c65f",
  null
  
)

export default component.exports